import React, { useEffect } from "react";
import { useLocalStore, useObserver } from "mobx-react";
import { SpinnerOverlay } from "@components";
import { makeStyles, Typography } from "@material-ui/core";
import { BookingContractVariantType } from "@bonliva-crm/shared";
import { CustomerContractProfile } from "@contracts/CustomerContractProfile/CustomerContractProfile";
import { ContractViewerStore } from "./ContractViewerStore";

type Props = {
  id: string;
  contractName: string;
};

const ContractViewer: React.FC<Props> = ({ id, contractName }) => {
  let store = useLocalStore(() => new ContractViewerStore(id));
  const classes = useStyles({});

  useEffect(() => {
    store = new ContractViewerStore(id);
  }, [id]);

  const content = (variant: BookingContractVariantType) => {
    switch (variant) {
      case BookingContractVariantType.Customer:
      case BookingContractVariantType.CustomerSubversion:
        return <CustomerContractProfile id={id} />;
      case BookingContractVariantType.Consultant:
      case BookingContractVariantType.ConsultantBookingConfirmation:
        return (
          <div style={{ position: "relative" }}>
            <SpinnerOverlay show={true} style={{ zIndex: 1 }} />
            <iframe src={`/consultant-contract/view/${id}`} className={classes.iframe} />
          </div>
        );
    }
  };
  return useObserver(() => {
    if (store.loading) {
      return <SpinnerOverlay transparent show />;
    }

    return (
      <>
        <div style={{ padding: 16 }}>
          <Typography variant={"h5"}>{contractName || store.data?.name}</Typography>
        </div>
        {content(store.data?.variant)}
      </>
    );
  });
};

const useStyles = makeStyles(() => ({
  iframe: {
    position: "relative",
    height: "200vh",
    border: 0,
    flex: 1,
    zIndex: 10,
    width: "100%"
  }
}));

export default ContractViewer;
